
import on_domready from "domready"
import * as log from "loglevel"
import env from "app/env"

declare global {
  interface Window {
    log: log.RootLogger,
  }
}

const map: {[key: string]: log.LogLevelNumbers} = {
  [env.Environments.DEVELOPMENT]: log.levels.TRACE,
  [env.Environments.TEST]:        log.levels.SILENT,
  [env.Environments.STAGING]:     log.levels.DEBUG,
  [env.Environments.PRODUCTION]:  log.levels.INFO,
}

const init = () => {
  // Ensure this function is executed after dom ready
  // Otherwise DOM access might be broken
  on_domready(() => {
    env.init()
    .then(({current_environment}) => {
      let level = map[current_environment]
      if (typeof level === "undefined") {
        log.error("We have an unexpected rails_env!")
        level = log.levels.TRACE
      }

      log.setDefaultLevel(level)
    })
  })
}

// Export to `window`
window.log = log


export default log

export {
  init,
}
